import './Navbar.css';
import Logo from '../../assets/Logo-VdHR.png';
import { Link } from 'react-router-dom';
import bars from '../../assets/bars.svg';

function Navbar() {
  const scrollToKontakt = () => {
    document.getElementById('kontakt').scrollIntoView();
  };
  return (
    <nav className="navbarNav">
      <div>
        <Link to="/">
          <img src={Logo} alt="VdHR-Logo" className="navLogo"></img>
        </Link>
      </div>
      <div className="navLinkListDiv">
        <img className="navLinkListMenu" alt="dropdown" src={bars}></img>
        <ul className="navLinkList">
          <li className="navLinkListItem">
            <Link to="/">VERBAND</Link>
          </li>
          <p className="navLinkListDot">•</p>
          <li className="navLinkListItem">
            <Link to="/mitglieder">MITGLIEDER</Link>
          </li>
          <p className="navLinkListDot">•</p>
          <li className="navLinkListItem">
            <Link to="/satzung">SATZUNG</Link>
          </li>
          {/* <p className="navLinkListDot">•</p>
          <li className="navLinkListItem">
            <Link to="/tarife">VERTRAGSGESTALTUNG</Link>
          </li> */}
          <p className="navLinkListDot">•</p>
          <li className="navLinkListItem">
            <Link to="/impressum">IMPRESSUM</Link>
          </li>
          <p className="navLinkListDot">•</p>
          <li className="navLinkListItem">
            <a onClick={scrollToKontakt}>KONTAKT</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
